import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import type { Disaster } from '@/types/accessor/api/disaster/disaster'
import { useNetworkStore } from './networkStore'
import { accessDataBasedOnNetwork } from '@/accessors/common/dataAccessorBasedOnNetwork'
import { GlobalError } from '@/utils/globalError/GlobalError'
import { ERROR_CODES } from '@/constants/error/errorCode'

export const useDisasterStore = defineStore(
  'disasterStore',
  () => {
    const disaster = ref<Disaster | null>(null)
    const disasters = ref<Disaster[]>([])

    const setDisaster = (newDisaster: Disaster) => {
      disaster.value = newDisaster
    }

    const setDisasters = (newDisasters: Disaster[]) => {
      disasters.value = newDisasters

      // 有効な災害IDをdisasterに格納
      const result = disasters.value.find(e => {
        return e.isEnabled
      })
      if (result !== undefined) {
        disaster.value = result
      }
    }

    const fetchAndSetDisasters = async (params: {
      govCode: string | undefined
      viewCode?: string
    }) => {
      if (params === undefined || params.govCode === undefined || params.govCode === '') return

      const networkStore = useNetworkStore()
      const disasterQueryParams = {
        system: 'disaster-emergency',
        govCode: params.govCode
      }
      const isOnline = networkStore.getIsOnline

      try {
        const resQueryDisaster = await accessDataBasedOnNetwork(
          'queryDisasterDaoApi',
          disasterQueryParams,
          isOnline,
          () => {
            networkStore.setOfflineStatus()
          }
        )

        if (typeof resQueryDisaster === 'object') {
          setDisasters(resQueryDisaster.result)
        }
      } catch (err) {
        console.error(err)
        throw new GlobalError([ERROR_CODES.HOME_DISASTER_GET_FAILED])
      }
    }

    const govCode = computed(() => disaster.value?.govCode)
    const disasterId = computed(() => disaster.value?.disasterId)
    //     const disasterTypes = computed(() => disaster.value?.disasterTypes)
    const disasterName = computed(() => disaster.value?.disasterName)
    const occurrenceDate = computed(() => disaster.value?.occurrenceDate)
    const isEnabled = computed(() => disaster.value?.isEnabled)
    //    const recommendedDisasterType = computed(() => disaster.value?.recommendedDisasterType)

    const reset = () => {
      disaster.value = null
    }

    return {
      disaster,
      disasters,
      govCode,
      disasterId,
      //      disasterTypes,
      disasterName,
      occurrenceDate,
      isEnabled,
      //      recommendedDisasterType,
      setDisaster,
      fetchAndSetDisasters,
      reset
    }
  },
  {
    persist: true // 永続化の設定を追加
  }
)
